/* ============================================================
   Product main section
   1. Media gallery (Splide) — desktop thumb nav + mobile arrows,
      progress bar and "1/7" counter.
   2. Shop the look drawer — open/close, focus trap, quick add.
   ============================================================ */
(function () {
  'use strict';

  /* ---- shared: add a variant straight to cart ---- */
  function addVariantToCart(variantId) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw data;
          return data;
        });
      })
      .then(function (data) {
        // refresh cart count
        fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            if (typeof window.updateCartCountDisplay === 'function') {
              window.updateCartCountDisplay(cart.item_count);
            } else {
              var el = document.querySelector('.cart-count');
              if (el) el.innerHTML = cart.item_count > 0 ? cart.item_count : '';
            }
          })
          .catch(function () {});
        return data;
      });
  }

  function openCart() {
    if (typeof load_cart === 'function') {
      load_cart().then(function () {
        if (typeof openCartDrawer === 'function') openCartDrawer();
      });
    } else if (typeof openCartDrawer === 'function') {
      openCartDrawer();
    }
  }

  /* ========================================================
     1. MEDIA GALLERY
     ======================================================== */
  function initGallery(section) {
    if (typeof Splide === 'undefined') return;

    var splideEl = section.querySelector('.product-media__splide');
    if (!splideEl || splideEl.classList.contains('is-initialized')) return;

    var media = section.querySelector('[data-product-media]');
    var thumbs = [].slice.call(section.querySelectorAll('.product-media__thumb'));
    var prev = section.querySelector('.product-media__arrow--prev');
    var next = section.querySelector('.product-media__arrow--next');
    var bar = section.querySelector('.product-media__progress-bar');
    var current = section.querySelector('.product-media__counter-current');

    var sp = new Splide(splideEl, {
      type: 'slide',
      drag: true,
      snap: true,
      perPage: 1,
      perMove: 1,
      pagination: false,
      arrows: false,
      speed: 400,
      easing: 'cubic-bezier(0.16, 1, 0.3, 1)',
      rewind: false
    });

    var isScrolling = false;
    var scrollTimeout = null;
    splideEl.addEventListener('wheel', function (e) {
      var absX = Math.abs(e.deltaX);
      var absY = Math.abs(e.deltaY);
      if (absX > absY && absX > 5) {
        e.preventDefault();
        if (!isScrolling) {
          isScrolling = true;
          if (e.deltaX > 0) sp.go('>');
          else if (e.deltaX < 0) sp.go('<');
        }
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(function () { isScrolling = false; }, 200);
      }
    }, { passive: false });

    function sync(index) {
      var activeIndex = typeof index === 'number' ? index : sp.index;
      var total = sp.length || 1;

      thumbs.forEach(function (t, i) {
        var active = i === activeIndex;
        t.classList.toggle('is-active', active);
        t.setAttribute('aria-selected', active ? 'true' : 'false');
        if (active && t.scrollIntoView) {
          t.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        }
      });

      if (prev) prev.disabled = activeIndex <= 0;
      if (next) next.disabled = activeIndex >= sp.Components.Controller.getEnd();
      if (bar) bar.style.width = (((activeIndex + 1) / total) * 100) + '%';
      if (current) current.textContent = activeIndex + 1;
    }

    sp.on('mounted move moved updated', sync);
    sp.mount();

    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () { sp.go(i); });
    });
    if (prev) prev.addEventListener('click', function () { sp.go('<'); });
    if (next) next.addEventListener('click', function () { sp.go('>'); });

    if (media) media.dataset.galleryInit = 'true';
  }

  /* ========================================================
     2. SHOP THE LOOK
     ======================================================== */
  function initShopTheLook(section) {
    var drawer = section.querySelector('[data-stl]');
    var trigger = section.querySelector('[data-stl-open]');
    if (!drawer || !trigger || drawer.dataset.stlInit) return;
    drawer.dataset.stlInit = 'true';

    var panel = drawer.querySelector('.stl__panel');
    var closeEls = [].slice.call(drawer.querySelectorAll('[data-stl-close]'));
    var lastFocus = null;
    var openQb = null; // currently-open quick-buy sheet

    function focusable() {
      return [].slice.call(
        panel.querySelectorAll('a[href], button:not([disabled]), select, [tabindex]:not([tabindex="-1"])')
      ).filter(function (el) { return el.offsetParent !== null; });
    }

    function open() {
      lastFocus = document.activeElement;
      
      // Reset all size dropdown labels back to default on open
      drawer.querySelectorAll('.js-custom-variant-selector-look .selected-value').forEach(function (el) {
        var defaultLabel = el.getAttribute('data-default-label');
        if (defaultLabel) el.textContent = defaultLabel;
      });
      // Reset custom dropdown state (close lists and update aria-expanded)
      drawer.querySelectorAll('.js-custom-variant-selector-look.is-open').forEach(function (el) {
        el.classList.remove('is-open');
        el.classList.remove('open-upside');
        var toggle = el.querySelector('.selector-toggle');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
      });

      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      trigger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      var closeBtn = drawer.querySelector('.stl__close');
      if (closeBtn) closeBtn.focus();
      document.addEventListener('keydown', onKey);
    }

    function close() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      trigger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      document.removeEventListener('keydown', onKey);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    function onKey(e) {
      if (e.key === 'Escape') {
        if (openQb) { closeQb(); return; } // close the quick-buy sheet first
        close();
        return;
      }
      if (e.key !== 'Tab') return;
      var items = focusable();
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }

    /* Backstop: this panel sits far down the DOM (a sibling after the whole
       .product-meta block, not near its trigger), so if focus ever escapes
       it while open — for any reason the boundary check above missed — Tab
       would otherwise fall through into a long detour of unrelated PDP
       content instead of stopping at the drawer. */
    document.addEventListener('focusout', function () {
      if (!drawer.classList.contains('is-open')) return;
      setTimeout(function () {
        var active = document.activeElement;
        if (active && panel.contains(active)) return;
        var closeBtn = panel.querySelector('.stl__close');
        if (closeBtn) closeBtn.focus();
      }, 0);
    });

    trigger.addEventListener('click', open);
    closeEls.forEach(function (el) { el.addEventListener('click', close); });

    /* ---- quick add inside the drawer ---- */
    function showError(card, msg) {
      var err = card.querySelector('.stl-card__error');
      if (!err) return;
      err.textContent = msg || 'Something went wrong.';
      setTimeout(function () { err.textContent = ''; }, 2500);
    }

    function quickAdd(card, variantId) {
      if (!variantId) return;
      addVariantToCart(variantId)
        .then(function () {
          close();
          if (typeof showCartNotification === 'function') {
            showCartNotification(variantId);
          } else {
            openCart();
          }
        })
        .catch(function (data) { showError(card, data && data.description); });
    }

    // Custom variant selector toggle for shop-the-look card (Desktop)
    drawer.querySelectorAll('.js-custom-variant-selector-look .selector-toggle').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var parent = btn.closest('.js-custom-variant-selector-look');
        var isOpen = parent.classList.contains('is-open');
        
        // Close other open selector dropdowns in the drawer
        drawer.querySelectorAll('.js-custom-variant-selector-look.is-open').forEach(function (el) {
          if (el !== parent) {
            el.classList.remove('is-open');
            el.classList.remove('open-upside');
          }
        });
        
        if (!isOpen) {
          var rect = btn.getBoundingClientRect();
          var spaceBelow = window.innerHeight - rect.bottom;
          if (spaceBelow < 250) {
            parent.classList.add('open-upside');
          } else {
            parent.classList.remove('open-upside');
          }
        } else {
          parent.classList.remove('open-upside');
        }

        parent.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', !isOpen);
      });
    });

    // Custom variant selector option select for shop-the-look card
    function selectVariantOption(option) {
      if (option.classList.contains('variant__sold-out') || option.hasAttribute('disabled')) return;

      var parent = option.closest('.js-custom-variant-selector-look');
      var toggleValue = parent.querySelector('.selected-value');
      if (toggleValue) {
        toggleValue.textContent = option.textContent.trim();
      }
      var toggle = parent.querySelector('.selector-toggle');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');

      var variantId = option.getAttribute('data-value');
      if (!variantId) return;

      quickAdd(option.closest('[data-stl-card]'), variantId);
      parent.classList.remove('is-open');
      parent.classList.remove('open-upside');
      // The option itself is about to be hidden — return focus to the
      // toggle instead of leaving it stranded on a now-invisible element.
      if (toggle) toggle.focus();
    }

    drawer.querySelectorAll('.js-custom-variant-selector-look .selector-option').forEach(function (option) {
      option.addEventListener('click', function (e) {
        e.stopPropagation();
        selectVariantOption(option);
      });
      option.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        e.preventDefault();
        e.stopPropagation();
        selectVariantOption(option);
      });
    });

    // Click outside to close selectors inside the drawer
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.js-custom-variant-selector-look')) {
        drawer.querySelectorAll('.js-custom-variant-selector-look.is-open').forEach(function (el) {
          el.classList.remove('is-open');
          el.classList.remove('open-upside');
        });
      }
    });

    // Single-variant direct add
    drawer.querySelectorAll('[data-stl-add]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        quickAdd(btn.closest('[data-stl-card]'), btn.dataset.variantId);
      });
    });

    /* ---- mobile quick-buy size sheet ---- */
    function closeQb() {
      if (!openQb) return;
      openQb.classList.remove('is-open');
      openQb.setAttribute('aria-hidden', 'true');
      openQb = null;
    }

    function qbError(sheet, msg) {
      var err = sheet && sheet.querySelector('.qb__error');
      if (!err) return;
      err.textContent = msg || 'Something went wrong.';
      setTimeout(function () { err.textContent = ''; }, 2500);
    }

    // Bag icon → open the matching size sheet (or add directly when single variant)
    drawer.querySelectorAll('[data-stl-quick]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var targetId = btn.getAttribute('data-qb-target');
        if (!targetId) { // single variant
          quickAdd(btn.closest('[data-stl-card]'), btn.dataset.variantId);
          return;
        }
        var sheet = document.getElementById(targetId);
        if (!sheet) return;
        closeQb();
        sheet.classList.add('is-open');
        sheet.setAttribute('aria-hidden', 'false');
        openQb = sheet;
      });
    });

    drawer.querySelectorAll('[data-qb-close]').forEach(function (el) {
      el.addEventListener('click', closeQb);
    });

    // Available size → add to cart
    drawer.querySelectorAll('[data-qb-add]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var sheet = btn.closest('[data-qb]');
        var variantId = btn.dataset.variantId;
        addVariantToCart(variantId)
          .then(function () {
            closeQb();
            close();
            if (typeof showCartNotification === 'function') {
              showCartNotification(variantId);
            } else {
              openCart();
            }
          })
          .catch(function (data) { qbError(sheet, data && data.description); });
      });
    });

    // Unavailable size → notify me (back-in-stock flow pending from client)
    drawer.querySelectorAll('[data-qb-notify]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        btn.classList.add('is-notified');
        /* TODO: connect to the back-in-stock app once the client provides the flow. */
      });
    });
  }

  /* ========================================================
     META: size selection, ATC, size guide, USPs, wishlist
     ======================================================== */
  function initMeta(section) {
    var form = section.querySelector('.product-form-main');
    if (form && !form.dataset.metaInit) {
      form.dataset.metaInit = 'true';
      initProductForm(section, form);
    }
    initSizeGuide(section);

    // USP delivery: Today before cut-off / Tomorrow after (CET or CEST)
    section.querySelectorAll('[data-usp-delivery]').forEach(function (el) {
      var parts = (el.getAttribute('data-time') || '21:00').split(':');
      var cutoff = (parseInt(parts[0], 10) || 0) * 60 + (parseInt(parts[1], 10) || 0);
      var offset = el.getAttribute('data-cest') === 'true' ? 2 : 1;
      var now = new Date();
      var local = (now.getUTCHours() * 60 + now.getUTCMinutes() + offset * 60) % 1440;
      el.textContent = local < cutoff ? el.getAttribute('data-before') : el.getAttribute('data-after');
    });

    // Wishlist (Klaviyo Customer Hub — client set-up; UI only for now)
    section.querySelectorAll('[data-wishlist]').forEach(function (btn) {
      if (btn.dataset.wishInit) return;
      btn.dataset.wishInit = 'true';
      btn.addEventListener('click', function () {
        btn.setAttribute('aria-pressed', btn.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
        /* TODO: connect to Klaviyo Customer Hub wishlist once the client sets it up. */
      });
    });
  }

  function initProductForm(section, form) {
    var idInput = form.querySelector('[data-variant-id-input]');
    var sizeWrap = form.querySelector('[data-product-size]');
    var atc = form.querySelector('[data-atc]');
    var notifyAtc = form.querySelector('[data-notify-atc]');
    var stickyBar = section.querySelector('[data-product-sticky-bar]');
    var stickyAtc = stickyBar ? stickyBar.querySelector('[data-sticky-atc-btn]') : null;
    var stickyNotify = stickyBar ? stickyBar.querySelector('[data-sticky-notify-btn]') : null;
    var errorEl = form.querySelector('[data-size-error]');
    var options = [].slice.call(form.querySelectorAll('[data-size-option]'));
    var ddToggle = form.querySelector('[data-dd-toggle]');
    var ddLabel = form.querySelector('[data-dd-label]');
    var ddList = form.querySelector('[data-dd-list]');
    var selectedMsg = form.querySelector('[data-size-selected]');
    var selected = options.length ? null : (idInput ? idInput.value : null);

    function triggerKlaviyoBis(variantId) {
      if (!variantId) return;
      var vId = String(variantId);
      var productId = form.getAttribute('data-product-id') || (notifyAtc ? notifyAtc.getAttribute('data-product-id') : '');

      if (idInput) {
        idInput.value = vId;
        try { idInput.dispatchEvent(new Event('change', { bubbles: true })); } catch (e) {}
      }

      var hiddenTrigger = document.getElementById('klaviyo-bis-trigger');
      if (hiddenTrigger) {
        if (productId) hiddenTrigger.setAttribute('data-product-id', productId);
        hiddenTrigger.setAttribute('data-variant-id', vId);
        try {
          hiddenTrigger.click();
        } catch (e) {}
      } else {
        try {
          if (window.klaviyo && typeof window.klaviyo.push === 'function') {
            window.klaviyo.push(['openBisModal', vId]);
          }
        } catch (e) {}
      }

      var syncModalVariant = function () {
        var modalSelect = document.querySelector('#klaviyo-bis-modal select, select#variant_select, .klaviyo-bis-modal select');
        if (modalSelect) {
          modalSelect.value = vId;
          try { modalSelect.dispatchEvent(new Event('change', { bubbles: true })); } catch (e) {}
        }
      };

      setTimeout(syncModalVariant, 50);
      setTimeout(syncModalVariant, 200);
      setTimeout(syncModalVariant, 500);
    }

    if (notifyAtc) {
      notifyAtc.addEventListener('click', function (e) {
        e.preventDefault();
        var vId = notifyAtc.getAttribute('data-variant-id') || (idInput ? idInput.value : null);
        triggerKlaviyoBis(vId);
      });
    }

    if (stickyNotify) {
      stickyNotify.addEventListener('click', function (e) {
        e.preventDefault();
        var vId = stickyNotify.getAttribute('data-variant-id') || (idInput ? idInput.value : null);
        triggerKlaviyoBis(vId);
      });
    }

    function setError(on) {
      if (sizeWrap) sizeWrap.classList.toggle('has-error', on);
      if (!errorEl) return;
      if (on) errorEl.removeAttribute('hidden');
      else errorEl.setAttribute('hidden', '');
    }

    // Header low-stock message: "38 ■ Only 3 left"
    function setSelectedMsg(btn) {
      if (!selectedMsg) return;

      var low = btn.getAttribute('data-low');

      if (low) {
        var template = selectedMsg.getAttribute('data-only-left-template') || 'Only [count] left';
        var text = template.replace('[count]', low);

        selectedMsg.innerHTML = `
          <span class="product-size__value">${btn.getAttribute('data-name') || ''}</span>
          <i class="product-size__marker"></i>
          <span class="product-size__stock">${text}</span>
        `;

        selectedMsg.removeAttribute('hidden');
      } else {
        selectedMsg.innerHTML = '';
        selectedMsg.setAttribute('hidden', '');
      }
    }

    function select(element) {
      var btn = element ? (element.closest('[data-size-option]') || element) : null;
      if (!btn) return;

      selected = btn.getAttribute('data-variant-id') || btn.dataset.variantId;
      var availAttr = btn.getAttribute('data-available');
      var isAvailable = availAttr === 'true';

      if (idInput) {
        idInput.value = selected;
        try { idInput.dispatchEvent(new Event('change', { bubbles: true })); } catch (e) {}
      }

      var hiddenTrigger = document.getElementById('klaviyo-bis-trigger');
      if (hiddenTrigger) {
        hiddenTrigger.setAttribute('data-variant-id', selected);
      }

      // Update URL query string with selected variant ID (clean URL: /products/handle?variant=123)
      if (selected && window.history && window.history.replaceState) {
        var cleanUrl = window.location.pathname + '?variant=' + selected;
        window.history.replaceState({ path: cleanUrl }, '', cleanUrl);
      }

      // Update TikTok / Catalog meta tags & pixel tracking
      if (selected) {
        var metaItems = document.querySelectorAll('meta[property="product:retailer_item_id"], meta[property="og:product:retailer_item_id"]');
        metaItems.forEach(function(m) { m.setAttribute('content', selected); });
        if (window.ttq && typeof window.ttq.track === 'function') {
          try { window.ttq.track('ViewContent', { content_id: selected, content_type: 'product' }); } catch (e) {}
        }
      }

      options.forEach(function (o) { o.classList.remove('is-selected'); });
      btn.classList.add('is-selected');
      setError(false);
      setSelectedMsg(btn);

      // Toggle Add to Cart button vs Notify Me button
      var toggleBtn = function(el, show) {
        if (!el) return;
        if (show) {
          el.classList.remove('is-hidden');
          el.removeAttribute('hidden');
          el.style.removeProperty('display');
          el.style.display = 'inline-flex';
        } else {
          el.classList.add('is-hidden');
          el.setAttribute('hidden', '');
          el.style.setProperty('display', 'none', 'important');
        }
      };

      toggleBtn(atc, isAvailable);
      toggleBtn(stickyAtc, isAvailable);
      toggleBtn(notifyAtc, !isAvailable);
      toggleBtn(stickyNotify, !isAvailable);

      if (!isAvailable) {
        if (notifyAtc) notifyAtc.setAttribute('data-variant-id', selected);
        if (stickyNotify) stickyNotify.setAttribute('data-variant-id', selected);
      }

      if (ddLabel) {
        var name = btn.querySelector('.product-size__opt-name');
        ddLabel.textContent = (name || btn).textContent.trim();
      }
      if (ddList) {
        ddList.setAttribute('hidden', '');
        if (ddToggle) ddToggle.setAttribute('aria-expanded', 'false');
      }
    }

    options.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        select(btn);
      });
    });

    if (ddToggle && ddList) {
      ddToggle.addEventListener('click', function () {
        var open = ddToggle.getAttribute('aria-expanded') === 'true';
        ddToggle.setAttribute('aria-expanded', String(!open));
        if (open) ddList.setAttribute('hidden', '');
        else ddList.removeAttribute('hidden');
      });
      document.addEventListener('click', function (e) {
        if (!form.contains(e.target)) {
          ddList.setAttribute('hidden', '');
          ddToggle.setAttribute('aria-expanded', 'false');
        }
      });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (options.length && !selected) {
        setError(true);
        if (sizeWrap) {
          sizeWrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        return;
      }
      var variantId = idInput ? idInput.value : null;
      if (!variantId) return;
      if (atc) atc.classList.add('loading');
      addVariantToCart(variantId)
        .then(function () {
          if (typeof showCartNotification === 'function') {
            showCartNotification(variantId);
          } else {
            openCart();
          }
        })
        .catch(function (data) { if (data && data.description) alert(data.description); })
        .then(function () { if (atc) atc.classList.remove('loading'); });
    });
  }

  function initSizeGuide(section) {
    var sg = section.querySelector('[data-size-guide]');
    if (!sg || sg.dataset.sgInit) return;
    sg.dataset.sgInit = 'true';

    var panel = sg.querySelector('.sg__panel');
    var lastFocus = null;

    function focusable() {
      return [].slice.call(
        panel.querySelectorAll('a[href], button:not([disabled]), select, [tabindex]:not([tabindex="-1"])')
      ).filter(function (el) { return el.offsetParent !== null; });
    }

    function open() {
      lastFocus = document.activeElement;
      sg.classList.add('is-open');
      sg.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      var closeBtn = sg.querySelector('.sg__close');
      if (closeBtn) closeBtn.focus();
      document.addEventListener('keydown', onKey);
    }
    function close() {
      sg.classList.remove('is-open');
      sg.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      document.removeEventListener('keydown', onKey);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    function onKey(e) {
      if (e.key === 'Escape') { close(); return; }
      if (e.key !== 'Tab') return;
      var items = focusable();
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }

    /* Backstop: this panel sits far down the DOM (a sibling after the whole
       .product-meta block, not near its trigger), so if focus ever escapes
       it while open — for any reason the boundary check above missed — Tab
       would otherwise fall through into a long detour of unrelated PDP
       content instead of stopping at the drawer. */
    document.addEventListener('focusout', function () {
      if (!sg.classList.contains('is-open')) return;
      setTimeout(function () {
        var active = document.activeElement;
        if (active && panel.contains(active)) return;
        var closeBtn = panel.querySelector('.sg__close');
        if (closeBtn) closeBtn.focus();
      }, 0);
    });

    section.querySelectorAll('[data-size-guide-open]').forEach(function (b) {
      b.addEventListener('click', open);
    });
    sg.querySelectorAll('[data-size-guide-close]').forEach(function (b) {
      b.addEventListener('click', close);
    });

    // Highlight the size row on hover (desktop) / tap (mobile)
    var table = sg.querySelector('[data-size-table] table');
    if (table) {
      var rows = [].slice.call(table.querySelectorAll('tbody tr'));
      function highlight(tr) {
        rows.forEach(function (r) { r.classList.remove('is-active'); });
        tr.classList.add('is-active');
      }
      rows.forEach(function (tr) {
        tr.addEventListener('mouseenter', function () { highlight(tr); });
        tr.addEventListener('click', function () { highlight(tr); });
      });
    }
  }

  /* ========================================================
     3. MEDIA ZOOM (Fancybox v5 — requires a commercial license)
     Fullscreen gallery: click-to-zoom, arrows, thumbnails, ESC,
     drag/pinch. Bound once via event delegation.
     ======================================================== */
  var zoomBound = false;
   function initZoom() {
    if (zoomBound || typeof Fancybox === 'undefined') return;
    zoomBound = true;
    Fancybox.bind('[data-fancybox^="ProductMedia-"]', {
      Hash: false,
      Images: {
        zoom: true,
        initialSize: 'fit',
        click: 'toggleMax',
        Panzoom: {
          fit: 'contain',
          maxScale: 2,
          panMode: 'mousemove',
          mouseMoveFactor: 1.15,
          mouseMoveFriction: 0.1
        }
      },
      Thumbs: {
        type: 'classic',
        Carousel: {
          center: false
        }
      },
      Toolbar: {
        items: {
          close: {
            tpl: '<button data-fancybox-close class="f-button is-close-btn" aria-label="Close"><span>CLOSE</span> <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21.9875 6.25L15 13.2375L8.0125 6.25L6.25 8.0125L13.2375 15L6.25 21.9875L8.0125 23.75L15 16.7625L21.9875 23.75L23.75 21.9875L16.7625 15L23.75 8.0125L21.9875 6.25Z" fill="#000000"/></svg></button>'
            }
        },
        display: {
          left: [],
          middle: [],
          right: ["close"]
        }
      },
      closeButton: false,
      Carousel: {
        Navigation: {
          prevTpl: '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M7.625 12.5L3.125 8L7.625 3.5M3.75 8H12.875" stroke="#72767F" stroke-linecap="round" stroke-linejoin="round"/></svg>',
          nextTpl: '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M8.375 3.5L12.875 8L8.375 12.5M12.25 8H3.125" stroke="#72767F" stroke-linecap="round" stroke-linejoin="round"/></svg>'
        }
      },
      on: {
        "Carousel.change": (fancybox, carousel) => {
          const currentSlide = fancybox.getSlide();
          if (currentSlide && currentSlide.panzoom) {
            const currentZoom = currentSlide.panzoom.state.scale;
            if (currentZoom > 1) {
              fancybox.persistedZoom = currentZoom;
            } else {
              fancybox.persistedZoom = null;
            }
          }
          setTimeout(() => {
            const newSlide = fancybox.getSlide();
            if (newSlide && fancybox.persistedZoom && newSlide.panzoom) {
              newSlide.panzoom.zoomTo(fancybox.persistedZoom, { friction: 0 });
            }
          }, 0);
        },
        "done": (fancybox, slide) => {
          if (fancybox.persistedZoom && slide.panzoom && fancybox.getSlide() === slide) {
            slide.panzoom.zoomTo(fancybox.persistedZoom, { friction: 0 });
          }
        }
      }
    });
  }

  /* ========================================================
     4. MOBILE STICKY ATC BAR
     ======================================================== */
  function initStickyATC(section) {
    var stickyBar = section.querySelector('[data-product-sticky-bar]');
    if (!stickyBar) return;
    if (stickyBar.dataset.stickyInit) return;
    stickyBar.dataset.stickyInit = 'true';
    
    var originalActions = section.querySelector('.product-meta__actions:not([data-product-sticky-bar] .product-meta__actions)');
    var stickyBtn = stickyBar.querySelector('[data-sticky-atc-btn]');
    
    if (!originalActions || !stickyBtn) return;

    stickyBtn.addEventListener('click', function (e) {
      e.preventDefault();
      var sizeWrap = section.querySelector('[data-product-size]');
      var sizeOptions = sizeWrap ? sizeWrap.querySelectorAll('[data-size-option]') : [];
      var selectedOption = sizeWrap ? sizeWrap.querySelector('[data-size-option].is-selected') : null;

      if (sizeOptions.length > 0 && !selectedOption) {
        if (sizeWrap) {
          sizeWrap.classList.add('has-error');
          var errorEl = sizeWrap.querySelector('[data-size-error]');
          if (errorEl) {
            errorEl.removeAttribute('hidden');
          }
        }
        originalActions.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } else {
        var originalAtc = originalActions.querySelector('[data-atc]');
        if (originalAtc) {
          originalAtc.click();
        }
      }
    });

    var ticking = false;

    function updateStickyBar() {
      if (!document.body.contains(stickyBar)) {
        window.removeEventListener('scroll', onScroll);
        window.removeEventListener('resize', onScroll);
        return;
      }

      if (window.innerWidth > 991) {
        stickyBar.classList.remove('is-active');
        return;
      }

      var originalRect = originalActions.getBoundingClientRect();
      var sectionRect = section.getBoundingClientRect();

      var isOriginalInViewport = !(originalRect.bottom < 0 || originalRect.top > window.innerHeight);
      var isInsideSection = sectionRect.bottom > 150;

      if (!isOriginalInViewport && isInsideSection) {
        stickyBar.classList.add('is-active');
      } else {
        stickyBar.classList.remove('is-active');
      }
    }

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(function () {
          updateStickyBar();
          ticking = false;
        });
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });

    updateStickyBar();
  }

  /* ========================================================
     boot
     ======================================================== */
  function init(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-product-section]').forEach(function (section) {
      initGallery(section);
      initShopTheLook(section);
      initMeta(section);
      initStickyATC(section);
    });
    initZoom();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // Theme editor support
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector && e.target.querySelector('[data-product-section]')) {
      init(e.target);
    }
  });
})();
